import { secureGet, securePost, securePut, secureDelete } from '../utils/HttpUtils';

const apiUrls = {
  clients: '/v1/private/clients/',
};

export const saveBalanceItems = async (
  cuit: string,
  applicationId: string,
  balance_sheet: any
) => {
  const url =
    apiUrls.clients +
    cuit +
    '/applications/' +
    applicationId +
    '/balance-sheets';
  return securePost(url, balance_sheet);
};

export const updateBalanceItems = async (
  cuit: string,
  applicationId: string,
  balanceSheetId: number,
  balance_sheet: any
) => {
  const url =
    apiUrls.clients +
    cuit +
    '/applications/' +
    applicationId +
    '/balance-sheets/' +
    balanceSheetId;
  return securePut(url, balance_sheet);
};

export const getBalanceInfoByCode = async (
  cuit: string,
  balanceSheetCode: string
) => {
  const url = apiUrls.clients + cuit + '/balance-sheets/' + balanceSheetCode;
  return secureGet(url);
};

export const getBalanceSheetsByCuit = async (cuit: string) => {
  const url = apiUrls.clients + cuit + '/balance-sheets';
  return secureGet(url);
};

export const postRiskData = async (cuit: string, id: string, body: any) => {
  const url =
    apiUrls.clients + cuit + '/applications/' + id + '/risk_analysis';
  return securePost(url, body);
};

export const putRiskData = async (cuit: string, id: string, body: any, riskAnalysisId: number) => {
  const url =
    apiUrls.clients + cuit + '/applications/' + id + '/risk_analysis/' + riskAnalysisId;
  return securePut(url, body);
};

export const getPostBalanceItems = async (
  cuit: string,
  id: string,
  yearTo: string,
  MonthTo: string
) => {
  const url =
    apiUrls.clients +
    cuit +
    '/applications/' +
    id +
    '/purchases-sales?' +
    'yearTo=' +
    yearTo +
    '&monthTo=' +
    MonthTo;
  return secureGet(url);
};

export const updatePostBalanceItems = async (
  cuit: string,
  application: any,
  id: string
) => {
  const url =
    apiUrls.clients +
    cuit +
    '/applications/' +
    id +
    '/post-balance-sheet-items';
  return securePut(url, application);
};

export const getDebts = async (cuit: string, code: string) => {
  const url = apiUrls.clients + cuit + '/debts/' + code;
  return secureGet(url);
};

export const saveDebts = async (cuit: string, applicationId: string) => {
  const url =
    apiUrls.clients + cuit + '/applications/' + applicationId + '/debts';
  return securePost(url, {});
};

export const updateDebts = async (
  cuit: string,
  applicationId: string,
  debtId: string,
  codes: string[]
) => {
  const url =
    apiUrls.clients +
    cuit +
    '/applications/' +
    applicationId +
    '/debts/' +
    debtId;
  return securePut(url, codes);
};

export const getRiskAnalysisWithDebts = async (
  cuit: string,
  applicationId: string,
  body: { codes: string[]; force_refresh?: boolean; previous_balance_sheet_code?: string },
) => {
  const url = `${apiUrls.clients}${cuit}/applications/${applicationId}/risk-analysis-with-debts`;
  return securePost(url, body);
};

// TODO: confirm URL with backend when endpoint is available
export const getCreditoMaximo = async (cuit: string, applicationId: string) => {
  const url = `${apiUrls.clients}${cuit}/applications/${applicationId}/credito-maximo`;
  return secureGet(url);
};

// TODO: confirm URL with backend when endpoint is available
export const calcularCreditoMaximo = async (
  cuit: string,
  applicationId: string,
  body: { revaluos: number; restricciones: number }
) => {
  const url = `${apiUrls.clients}${cuit}/applications/${applicationId}/credito-maximo/calcular`;
  return securePost(url, body);
};

// TODO: confirm URL with backend when endpoint is available
export const saveCreditoOtorgado = async (
  cuit: string,
  applicationId: string,
  body: {
    revaluos: number;
    restricciones: number;
    productos: Array<{
      product_id: number;
      cantidad_otorgada: string;
      monto_otorgado: string;
      product_line_code: string;
      currency_code: string;
      /** Enviar solo con cotizaciones: "" limpia activo en backend; omitir no toca activo (legacy). */
      asset_code?: string;
    }>;
  }
) => {
  const url = `${apiUrls.clients}${cuit}/applications/${applicationId}/credito-maximo`;
  return securePut(url, body);
};

export const addProductToApplication = async (
  cuit: string,
  applicationId: string,
  body: {
    product_line_code: string;
    currency_code: string;
    amount: number;
    asset_code?: string;
    asset_count?: number;
  }
) => {
  const url = `${apiUrls.clients}${cuit}/applications/${applicationId}/products`;
  return securePost(url, body);
};

export const deleteProductFromApplication = async (
  cuit: string,
  applicationId: string,
  productId: number
) => {
  const url = `${apiUrls.clients}${cuit}/applications/${applicationId}/products/${productId}`;
  return secureDelete(url);
};

export type GetFinancialIndicatorsParams = {
  balance_sheet_code?: string;
  previous_balance_sheet_code?: string;
};

/**
 * Indicadores financieros por empresa (Paso 4 – Resumen de Riesgo).
 * Nota: el path exacto lo define backend; este endpoint está pensado para ser
 * independiente de BPB/Nosis/etc y retornar indicadores activos ordenados.
 */
export const getFinancialIndicators = async (
  cuit: string,
  applicationId: string,
  params?: GetFinancialIndicatorsParams
) => {
  const query = new URLSearchParams();
  if (params?.balance_sheet_code) {
    query.set('balance_sheet_code', params.balance_sheet_code);
  }
  if (params?.previous_balance_sheet_code) {
    query.set('previous_balance_sheet_code', params.previous_balance_sheet_code);
  }

  const url =
    apiUrls.clients +
    cuit +
    '/applications/' +
    applicationId +
    '/financial-indicators' +
    (query.toString() ? `?${query.toString()}` : '');

  return secureGet(url);
};
